/******************************************************************
   Creates div dialog for return data or "hover stick" jquery dialogs
 ******************************************************************/
var mrcValidate = true;
var load = new Array();
var objAry = new Array();
//document.write('<script type="text/javascript" src="/mrcjava/mrcclasses/jquery.blockUI.js"></script>');
jQuery(document).ready(function () {
	jQuery('body').prepend('<div id="dialog" title=""></div>');
	jQuery('#dialog').dialog({
		autoOpen: false,
		modal: true,
		height: 'auto',
		width: '700',
		position: ['center', 100],
		bgiframe: true,
		draggable:true,
		   resizable:false,
		   overlay: { opacity: 0.7, background: 'black' },
		   dragStart:  function (event, ui) {jQuery('#dialog').block({ message: null,  overlayCSS:{ backgroundColor: '#FFF', opacity: .1 }});  },
		   dragStop:  function (event, ui) {jQuery('#dialog').unblock(); }
	});
	setupPopupDialog();
	var isIRT = jQuery('#select_menu').length;
	//if(isIRT == 0){ //2012-08-09 - comment out, and always run this code (also comment out call to this function in mrcreport.js
	if(typeof getJSVersion !== 'function'){//2018-12-27 - if this function exists, then ajax_forms will call the initializeajaxHelpers method
		jQuery('form,.single-row-retrieval').each(function () {//2014-07-01: add single-row-retrieval class
			initializeAjaxHelpers(this);
		});
	}
	initJqueryPlugins();
	jQuery('body').on('mousedown', 'select[readonly]', function (e) {
		e.preventDefault();
		return false;
	});
	 jQuery('input[data-key="true"][readonly]').datepicker('destroy'); // 2015-11-17, BD - #23994: Remove datepickers from key fields on V/U/D
});
function setupPopupDialog () {
	 jQuery('body').on('click', 'a[mrc=returndata]', function (e) {
		e.preventDefault();
		var app = jQuery(this).attr('href');
		var parmIndex = app.indexOf('?');
		var parms = app.substring(parmIndex + 1);
		var parmAry = parms.split('&');
		var splitParms;
		var height = 0;
		var width = 0;
		var text = '';
		var hoverRedir = '';
		var maxSize = 0;
		for (var i = 0; i < parmAry.length; i++) {
			splitParms = parmAry[i].split('=');
			if(splitParms[0] == 'height') {
				height = splitParms[1];
			}
			if(splitParms[0] == 'width') {
				width = splitParms[1];
			}
			if(splitParms[0] == 'text') {
				text = splitParms[1];
			}
			if(splitParms[0] == 'title') {
				text = splitParms[1];
			}
			if(splitParms[0] == 'windowtitle') {
				text = splitParms[1];
			}
			if(splitParms[0] == 'maxsize') {
				maxSize = splitParms[1];
			}
		}
		var hoverIndex = app.indexOf('&hover_redir');
		if(hoverIndex > 0) {
			hoverRedir = app.substring(hoverIndex + 13);
		}else {
			hoverRedir = '';
		}
		modalDialog(app, text, height, width, hoverRedir, maxSize);
	});
}
/******************************************************************
Check document for ajax helper attributes and apply to fields.
 ******************************************************************/

function resetJSFeatures () {//changed function name from irtCallback 2014-09-16
	makeSortable();
	setupPopupDialog();
}
/******************************************************************
	makesortable() sets up all widgets (tabs, accordion, portlets)
 ******************************************************************/
function makeSortable () {
	try{
		jQuery('div[mrctype=tabs]').tabs();

		jQuery('table[mrcsortable=yes] > tbody > tr> td').addClass('sort');
		var collapsed = jQuery('div[mrctype=accordion]').attr('collapsed');
		var xcollapsed;
		if(collapsed == 'yes') {
			xcollapsed = false;
		}else{
			xcollapsed = 0;
		}
		jQuery('div[mrctype=accordion]').accordion({
			autoHeight: false,
			collapsible: true,
			active: xcollapsed
		});
		jQuery('.sort').sortable({
			connectWith: '.sort',
			start: function (event, ui) {
				jQuery('.sort').css('background', '#CBDBE6');
				makePlaceholders(ui.item);
			},
			stop: function (event, ui) {
				jQuery('.sort').css('background', '').width('');
			},
			over: function (event, ui) {
				jQuery(this).css({'border-style':'dashed', 'border-width':'2px', 'border-color':'#000000'});
			},
			out: function (event, ui) {
				jQuery(this).css({'border-style':'', 'border-width':''});
			}
		}).disableSelection();
	}catch(err) {

	}
}
function checkUndefined (value) {
	if(value === undefined) {
		return '';
	}
	return value;
}
function loadPortlet (ui) {
	var url = jQuery(ui.item).attr('mrc_load');
	if(jQuery(ui.item).find('.portlet-content > table').length == 0) {
		jQuery.get(url, function (data) {
			jQuery(ui.item).find('.portlet-content').html(data);
			//togglePortletIcon(ui.item);
			jQuery('a[mrc_link=mx_link]').remove();
		});
	}else{
		togglePortletIcon(ui.item);
	}
	updateUserFile();

}
function togglePortletIcon (el) {
	jQuery(el).toggleClass('ui-icon-minusthick').toggleClass('ui-icon-plusthick');
	jQuery(el).find('.portlet-content').toggle();
	updateUserFile();
}
function unloadPortlet (ui) {
	togglePortletIcon(ui.item);
}
function makePlaceholders (ui) {
	var height = jQuery(ui).height();
	var width = jQuery(ui).width();
	// jQuery(".sort").height(height + 'px');
	jQuery('.sort').filter(function () {
		var html = jQuery(this).html();
		html = html.replace(/&nbsp;/ig, '');
		if(jQuery.trim(html) == '') {
			return true;
		}
	}).width('300px');
	//jQuery(".sort").width('300px');
}

/******************************************************************
Close dialog called from retrieval return data link
 ******************************************************************/
function closeDialog () {
	jQuery('#dialog').dialog('close');
}
/******************************************************************
modalDialog() called from link, receives parameters
for width and height as well as the target app to set in the dialog iframe.
 ******************************************************************/
function modalDialog (link, text, height, width, hoverRedir, maxSize) {
	var browser = navigator.appName;
	var mrcdialog = jQuery('#dialog');
	var resizewidth = false, resizeheight = false;

	if (width == 'auto') {//2016-07-14 - split  auto resizing into 2 separate blocks
		width = 1;
		resizewidth = true;
	}
	if( height == 'auto') {
		height = 1;
		resizeheight = true;
	 }
	if(maxSize && maxSize == 1) {//make the popup dialog full screen
		width = jQuery(window).width() - 55;
		height = jQuery(window).height() - 85;
		mrcdialog.dialog('option', 'position', []);
		mrcdialog.dialog('option', 'width', jQuery(window).width() - 50);
		mrcdialog.dialog('option', 'height', jQuery(window).height() - 50);
		resize = false;
	}else{
		mrcdialog.dialog('option', 'width', width);
		mrcdialog.dialog('option', 'height', 'auto');
	}

	mrcdialog.css('padding', 0);
	mrcdialog.dialog('option', 'title', text);
	mrcdialog.dialog('open');
	jQuery('.ui-widget-overlay').css('opacity', .40);
	jQuery('.ui-widget-overlay').css('background', 'black');
	mrcdialog.html( '<iframe id="modalIframeId" src="" title="' + text + '" style="position:relative;height:' + height + 'px;width:' + width + 'px;" marginheight="0" frameborder="0"  marginwidth="0"></iframe>');
	jQuery('#modalIframeId').load(function () {
		jQuery('#modalIframeId').contents().find('form').submit(function () {
			if(hoverRedir != '') {
				//mrcdialog.dialog('close');
				var functionCallIndex = hoverRedir.indexOf('call_'); //2012-10-12- if call_functionname is specified as redirect, try to call that function name
				if(functionCallIndex >= 0) {
					var functionName = hoverRedir.substring(functionCallIndex + 5);
					try{
						//setTimeout(function(){window[functionName]();},1000);
						jQuery('#modalIframeId').load(function () {
							var err1 = jQuery.trim(jQuery('#modalIframeId').contents().find('#message').val());
							if (err1 === '') {
								window[functionName]();
							} else {
								jQuery('#modalIframeId').unbind('load');
							}
						});
					}catch(err) {

					}
				}else{
					window.location = hoverRedir;
				}
			}
		});
		//2016-01-26 - for bug 24275
		if(resizewidth) {
			resizeModalWidth();
		}
		if (resizeheight) {
			resizeModalHeight();
		}else if(maxSize != 1) {
		  var  ht = jQuery('#dialog').height();
		  jQuery('#dialog').dialog('option', 'height', ht + 50);//prevent scroll bars
		}
	});
	jQuery('#modalIframeId').attr('src', link);
	return false;
}

//2016-07-14 - split modal resizing into 2 separate functions
function resizeModalHeight () {
	var iframe, ht, htOffset;
	// Set these offsets to give some space to the content

	htOffset = 10;
	dialogHtOffset = 120;
	iframe = jQuery('#modalIframeId');
	// Reset height and width to avoid the window growing every form submit
	ht = 1;
	iframe.css('height', ht).attr('height', ht);
	// Get and set the height and width of content
	ht = iframe.contents().height();
	iframe.css('height', ht + htOffset).attr('height', ht + htOffset);
	//2016-01-26 - for bug 24275
	jQuery('#dialog').dialog('option', 'height', ht + dialogHtOffset);//added to fix scroll bars
}
//2016-07-14 - split modal resizing into 2 separate functions
function resizeModalWidth () {
	var iframe, wd, wdOffset;
	// Set these offsets to give some space to the content
	wdOffset = 30;
	iframe = jQuery('#modalIframeId');
	// Reset height and width to avoid the window growing every form submit
	wd = 1;

	iframe.css('width', wd).attr('width', wd);
	// Get and set the height and width of content

	wd = iframe.contents().width();

	iframe.css('width', wd + wdOffset).attr('width', wd + wdOffset);
	jQuery('#dialog').dialog('option', 'width', wd + wdOffset);


}
/****************************************************************/
// Do not submit form until ajax callbacks complete
/****************************************************************/
function waitForCallBackComplete (form) {
	var mrcContinue = true;
	for(var i = 0; i < objAry.length;i++) {
		if( objAry[i].success == false) {
			mrcContinue = false;
			break;
		}
	}
	if( mrcContinue == false) {
		callTimeout(form);
	}else{
		for(var i = 0; i < objAry.length;i++) {

			if(objAry[i].valid == false) {
				mrcValidate = false;
				break;
			}
		}
		if( mrcValidate == true) {
			jQuery(form).submit();
		} else{
			return false;
		}
	}
}
function callTimeout (form) {
	setTimeout(function () { waitForCallBackComplete(form);}, 500);
}